import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { OcbAzureStorageServices } from '@app/core';
import { TranslateService } from '@ngx-translate/core';
import { DxSelectBoxComponent } from 'devextreme-angular';

@Component({
    selector: 'app-azure-service-type-picker',
    templateUrl: './azure-service-type-picker.component.html',
    styleUrls: ['./azure-service-type-picker.component.scss'],
})
export class AzureServiceTypePickerComponent {

    @Input()
    public selectedItem: string;

    @Input()
    public readOnly: boolean = false;

    @Output()
    public selectedItemChange = new EventEmitter<string>();

    @ViewChild(DxSelectBoxComponent)
    public selectBox: DxSelectBoxComponent;

    public serviceTypes: any[] = new Array<any>();
    public loading: boolean = true;

    public constructor(private translateService: TranslateService) {
        this.translateService.get('azureServiceTypes').subscribe(labels => {
            for (const serviceType in OcbAzureStorageServices) {
                if (isNaN(Number(serviceType))) {
                    this.serviceTypes.push({ name: labels[serviceType], id: OcbAzureStorageServices[serviceType] });
                }
            }
            this.loading = false;
        });
    }

    public onSelectedItemChange($event: { name: string, id: string }) {
        if ($event == null) {
            this.selectedItemChange.emit(null);
        } else {
            this.selectedItemChange.emit($event.id);
        }
    }
}
